import React, {Component} from 'react';
import {connect} from 'react-redux';
import ListOfContactsBodyHead from './components/list-of-contacts-body-head';
import ListOfContactsBodyContent from './components/list-of-contacts-body-content';
import './index.css';

class ListOfContactsBody extends Component {
    render() {
        return (
            <div className="list-of-contacts-body">
                <ListOfContactsBodyHead/>
	            <ListOfContactsBodyContent/>
            </div>
        );
    }
}
const mapStateToProps = (state) => {
	return {
		checkGmailAddOnData:state.profileReducer.setGmailAddOnData
	};
};
export default connect(mapStateToProps, null)(ListOfContactsBody);

